export const RESOURCE_TYPE_COLORS: Record<string, string> = {
  video: 'bg-red-500/10 text-red-600',
  article: 'bg-blue-500/10 text-blue-600',
  course: 'bg-purple-500/10 text-purple-600',
  book: 'bg-amber-500/10 text-amber-600',
  tool: 'bg-green-500/10 text-green-600',
}
